export default [
    {
        path: "/plaza-nominal/historial/:id",
        name: "plazas-historial",
        component: () =>
            import(/* webpackChunkName: "plazasHistorial" */ "./index.vue"),
    }
];
